import React, { useState, useCallback, useEffect } from 'react'
import { Card } from './Card'
import update from 'immutability-helper'
import { IColumn, IColumnsList } from "../interfaces";


const style = {
  width: 400,
}

export interface Item {
  id: number
  name: string
}

export const Container: React.FC<IColumnsList> = ({ toggleColumnPopUp, reportColumns, updateColumnsOrder }) => {
  {
    const [columns, setColumns] = useState(reportColumns);

    useEffect(() => {
      if (reportColumns.length != columns.length) {
        setColumns(reportColumns);
      }
      const ids = columns.reduce((a, b) => {
        return a.concat(b.id)
      }, []);
      updateColumnsOrder(ids);
    })

    const moveCard = useCallback(
      (dragIndex: number, hoverIndex: number) => {
        const dragCard = columns[dragIndex]
        setColumns(
          update(columns, {
            $splice: [
              [dragIndex, 1],
              [hoverIndex, 0, dragCard],
            ],
          }),
        );
        // setColumnsLoaded(false);
      },
      [columns],
    )

    const togglePopUp = useCallback(
      (isOpen, columnID) => toggleColumnPopUp(true, columnID),
      [columns],
    )

    const renderCard = (card: Item, index: number) => {
      const column = reportColumns.find((item) => item.id == card.id);
      return (
        <Card
          key={card.id}
          index={index}
          id={card.id}
          text={(column ? column.name : '')}
          moveCard={moveCard}
          toggleColumnPopUp={(isOpen, columnID) => togglePopUp(isOpen, columnID)}
        />
      )
    }

    if (columns && columns.length > 0) {
      return (
        <>
          <div>
            {
              columns.map((card, i) => renderCard(card, i))
            }
          </div>
        </>
      );
    } else {
      return (
        <p>Please add a column to activate the "Run Report" button.</p>
      );
    }
  }
}
